import { useGridUserDataGlobalFiltersContext } from 'contexts/GridUserDataGlobalFiltersProvider';
import { useTerminalsContext } from 'contexts/TerminalsProvider';

interface CurrentTerminal {
  id: number;
  should_process_splitted_pallets?: boolean;
}

/**
 * Terminal record of the globally selected terminal, the one the storage UI renders.
 */
export const useCurrentTerminal = (): CurrentTerminal | undefined => {
  const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();
  const { data: terminals } = useTerminalsContext();

  const terminalId = globalFilters?.terminal_id?.[0];

  return terminalId ? terminals?.[terminalId] : undefined;
};
